import { HostListener, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';

export abstract class TemplateDialogButtonBase {
  @ViewChild(TemplateRef) template: TemplateRef<any>;
  private _dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog, public snackBar: MatSnackBar) { }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }

  openDialog(): void {
    this._dialogRef = this.dialog.open(this.template);
  }

  closeDialog(): void {
    this._dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/template-dialog-button-base.ts